export const REQUEST_PROMO_PAGE = 'promoPage/REQUEST_PROMO_PAGE';
export const SET_PROMO_PAGE = 'promoPage/SET_PROMO_PAGE';

export const requestPromoPage = ({ promoUrl = 'default' }) => ({
  type: REQUEST_PROMO_PAGE,
  payload: {
    promoUrl
  }
});

export const setPromoPage = payload => ({
  type: SET_PROMO_PAGE,
  payload
});
